import addToCart from './utils/add-to-cart'
import BrowserCheck from './utils/browser-check'
import { demo } from './utils/demo'
import loadlytics from './utils/eightlytics/loadlytics'
import { cloneEvent } from './utils/event'
import { getCookieValue } from './utils/get-cookie'
import goToWidget from './utils/go-to-widget'
import initConfig from './utils/init-config'
import isBlacklisted from './utils/is-blacklisted'
import isWidgetHalfVisible from './utils/is-widget-half-visible'
import logger from './utils/logger'
import Option from './utils/option'
import reinitCSE from './utils/reinit-cse'
import request from './utils/request'
import showSysButton from './utils/show-sys-button'
import updateWidgetSku from './utils/update-widget-sku'
import whenDomIsReady from './utils/when-dom-is-ready'
import whenWidgetIsHalfVisible from './utils/when-widget-is-half-visible'
import WidgetLoader from './utils/widget-loader'

function cre8select(window8select) {
  if (getCookieValue('_8select-disable-cse') === 'true') {
    return
  }

  const _8select = window8select || {}

  if (_8select.isLoaded) {
    return _8select
  }

  _8select.isLoaded = true
  _8select.config = initConfig()

  if (isBlacklisted(_8select)) {
    return
  }

  const option = new Option('_8select_cse_config')
  const widgetLoader = new WidgetLoader(window)

  // @todo
  // clean this up and remove convenience methods to make the wgt-ldr small again
  // the apps need to be adjusted to use the new "inconvenient" functions
  _8select.utils = {
    addToCart,
    option,
    request,
    widgetLoader,
    showSysButton,
    isWidgetHalfVisible,
    whenWidgetIsHalfVisible,
    browsercheck: new BrowserCheck(window),
    goToWidget: goToWidget.bind(_8select),
    cloneAndDispatchEvent(event) {
      window.dispatchEvent(cloneEvent(event))
    },
  }

  if (_8select.config.featureFlags.observeDOM === true) {
    _8select.initCSE = function() {
      logger('initCSE() skipped - it is not necessary anymore.')
      logger('featureFlag observeDOM is enabled and all widget changes are handled automatically.')
    }
  } else {
    _8select.initCSE = widgetLoader.load.bind(widgetLoader)
  }
  _8select.reinitCSE = reinitCSE.bind(_8select)
  _8select.updateWidgetSku = updateWidgetSku.bind(_8select)
  _8select.reinitSys = function(sku) {
    console.debug(`8SELECT: _8select.reinitSys() is deprecated.
     Please use _8select.updateWidgetSku("widget-id", "new-sku") instead.`)
    _8select.updateWidgetSku('sys-psv', sku)
  }
  _8select.demo = demo.bind(_8select)

  loadlytics(window, _8select.config)

  whenDomIsReady(window).then(() => widgetLoader.load())

  return _8select
}

export default cre8select
